import {
  ILedgerLog,
  ILedgerTag,
  LedgerHead,
  LedgerSubhead,
} from "../interfaces/ledger";
import BaseService, { BaseServiceProps } from "./BaseService";

export class LedgerService extends BaseService {
  constructor() {
    super("ledger");
  }

  fetchByOwnerSpecific(payload: {
    head: LedgerHead;
    subhead: LedgerSubhead;
    owner: string;
  }): Promise<ILedgerLog> {
    const formData = new FormData();

    let _payload: any = { ...payload };
    Object.keys(_payload).forEach((key) => {
      formData.append(key, _payload[key]);
    });

    return new Promise((resolve, reject) => {
      const cacheKey = `ledger_${payload.head}_${payload.subhead}_${payload.owner}`;
      const cachedData = this.cache.get(cacheKey);

      if (cachedData) {
        resolve(cachedData);
      } else {
        try {
          this.http
            .post(`ledger/read_by_owner_specific`, formData)
            .then((data: any) => {
              if (data.code === 200 && data?.data?.length) {
                this.cache.set(cacheKey, data.data[0]);
                resolve(data.data[0]);
              } else reject({ message: data.message });
            });
        } catch (error) {
          reject({ message: "An unexpected error occured!" });
          throw error;
        }
      }
    });
  }

  fetchLogs(ledgerId: string): Promise<ILedgerLog> {
    return new Promise((resolve, reject) => {
      const cacheKey = `ledger_logs_${ledgerId}`;
      const cachedData = this.cache.get(cacheKey);
      if (cachedData) {
        resolve(cachedData);
      } else {
        try {
          this.http
            .get(`ledger_log/read_by_ledger/?ledger_id=${ledgerId}`)
            .then((data: any) => {
              if (data.code === 200) {
                this.cache.set(cacheKey, data.data);
                resolve(data.data);
              } else reject({ message: data.message });
            });
        } catch (error) {
          reject({ message: "An unexpected error occured!" });
          throw error;
        }
      }
    });
  }

  fetchTags(payload: {
    parent_id: string;
    parent_type: LedgerHead;
  }): Promise<ILedgerTag[]> {
    const formData = new FormData();

    const _payload: any = { ...payload };
    Object.keys(_payload).forEach((key) => {
      formData.append(key, _payload[key]);
    });

    return new Promise((resolve, reject) => {
      const cacheKey = `ledger_tags_${payload.parent_id}`;
      const cachedData = this.cache.get(cacheKey);
      if (cachedData) {
        resolve(cachedData);
      } else {
        try {
          this.http
            .post(`ledger_tag/read_by_parent/`, formData)
            .then((data: any) => {
              if (data.code == 200) {
                this.cache.set(cacheKey, data.data);
                resolve(data.data);
              } else reject({ message: data.message });
            });
        } catch (error) {
          reject({ message: "An unexpected error occured!" });
          throw error;
        }
      }
    });
  }

  initiatePaystackCheckout(payload: {
    parent_id: string;
    parent_type: LedgerHead;
    amount: number;
    callback_url: string
  }): Promise<any> {
    const formData = new FormData();

    const _payload: any = { ...payload };
    Object.keys(_payload).forEach((key) => {
      formData.append(key, _payload[key]);
    });

    return new Promise((resolve, reject) => {
      try {
        this.http
          .post(`ledger_tag/transfer_initiate`, formData)
          .then((data: any) => {
            if (data.code == 200) {
              if (data.data.status === true) {
                resolve(data.data.data);
              } else reject({ message: data.data.message });
            } else reject({ message: data.message });
          });
      } catch (error) {
        reject({ message: "An unexpected error occured!" });
        throw error;
      }
    });
  }
}

export default LedgerService;
export const ledgerService = new LedgerService();
export type LedgerServiceProps = BaseServiceProps | keyof LedgerService;
